import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { IExternalGMS } from '@cbgms/api'
import { useNotifier } from '@cbgms/base/notifier'
import ExternalGMSForm from 'gms-support/src/app-support/external-gms/components/ExternalGMSForm'
import { createExternalGMS } from 'gms-support/src/app-support/external-gms/state/actions'
import { useHistory } from 'react-router-dom'

const emptyInitialValues = {
  UUID: '',
  Name: '',
  CountryCode: '',
  HasRemark: false,
  IsNone: false,
  ImageURL: '',
  CreatedAt: '',
  UpdatedAt: ''
}

const New = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const notifier = useNotifier()

  const onSubmit = async (values: IExternalGMS) => {
    try {
      const { CreatedAt: _, UpdatedAt: __, UUID: ___, ...newValues } = values
      const {
        Data: { UUID }
      } = await dispatch(createExternalGMS(newValues))

      return { ...values, UUID }
    } catch (error) {
      throw error
    }
  }

  const onSubmitSuccess = async ({ UUID }: IExternalGMS) => {
    notifier.success(t('external_gms.successfully_created'))
    history.push(`/external-gms/edit/${UUID}`)
  }

  return (
    <ExternalGMSForm
      headerText='external_gms.title'
      onSubmit={onSubmit}
      onSubmitSuccess={onSubmitSuccess}
      form='new_external_gms'
      initialValues={emptyInitialValues}
    />
  )
}

export default New
